var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpikeTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 491,
    viewBox: "0 0 337 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.777 73.1094L72.1005 487.93L340.877 92.3996",
    stroke: "url(#paint0_radial_16640_54370)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.227 -2.40625L94.2991 95.9824L304.759 38.1496",
    stroke: "url(#paint1_radial_16640_54370)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16640_54370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.764 280.36) rotate(120.132) scale(209.188 1449.01)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16640_54370",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.238 46.6325) rotate(153.262) scale(98.2968 942.029)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpikeTr);
export default __webpack_public_path__ + "static/media/spikeTR.b56de47a077b0e46ad20355c3c221296.svg";
export { ForwardRef as ReactComponent };